import config from 'devextreme/core/config'; 
import { licenseKey } from './devextreme-license.ts'; 
 

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';

import { createApp } from "vue";
import router from "./router";

import App from "./App";
import appInfo from "./app-info";
import store from './store';

config({ licenseKey });  

const app = createApp(App)

app.use(router)
app.use(store)
app.config.globalProperties.$appInfo = appInfo;
app.mount("#app");
